/** @jsx jsx */
import { jsx } from '@emotion/core'
import { DocType, DocumentView } from './DocumentView'

const PrivacyPolicy = () => {
    return <DocumentView type={DocType.privacyPolicy} />
}

export { PrivacyPolicy }
